export function getCookie(name: string): string | null {
  const part = document.cookie
    .split(';')
    .map((v) => v.trim())
    .find((v) => v.startsWith(`${name}=`))
  if (!part) return null
  return decodeURIComponent(part.slice(name.length + 1))
}

export function setCookie(name: string, value: string, days = 365): void {
  const d = new Date()
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/`
}

